import Vue from 'vue'
import {
  TOP_ACTIVE_MENU
} from '@/store/mutation-types'
import { BasicLayout } from '@/layouts'
import { loadView } from '@/store/modules/routeLoader'

/**
 * 过滤账户是否拥有某一个权限，并将菜单从加载列表移除
 *
 * @param permission
 * @param route
 * @returns {boolean}
 */
function hasPermission (permission, route) {
  // if (route.meta && route.meta.permission) {
  //   let flag = false
  //   for (let i = 0, len = permission.length; i < len; i++) {
  //     flag = route.meta.permission.includes(permission[i])
  //     if (flag) {
  //       return true
  //     }
  //   }
  //   return false
  // }
  return true
}
function getRouters(resources){
  if(resources){
    let root = [{
      path: '/',
      name: 'dynamicRoot',
      component: BasicLayout,
      meta: { title: '首页',key:'ROOT_INDEX' },
      redirect: resources?resources[0].url:'/',
      children: []
    },{
      path: '*', redirect: '/404', hidden: true
    }]
    let arr = [];
    let childrenMenu = buildChildren(resources,arr);
    root[0].children = childrenMenu
    localStorage.setItem("resourceCodes",JSON.stringify(arr))
    console.log(root)
    return root;
  }
  return {}
}

function buildChildren(children,arr){
  let childrenResource = []
  children.forEach(resource=>{
    let menu = {meta: { title: resource.title, hiddenHeaderContent: true, icon: 'read' }}
    menu.name = resource.name
    arr.push(resource.name);
    menu.path = resource.url
    menu.meta.icon = resource.icon
    menu.meta.activeIcon = resource.activeIcon
    menu.meta.title = resource.title
    menu.meta.key = resource.name
    menu.component = loadView(resource.filePath)
    if(resource.children){
      let childresMenu = buildChildren(resource.children,arr)
      menu.children = childresMenu;
      menu.redirect = childresMenu[0].path
    }
    childrenResource.push(menu)
  })
  return childrenResource;
}
/**
 * 单账户多角色时，使用该方法可过滤角色不存在的菜单
 *
 * @param roles
 * @param route
 * @returns {*}
 */
// eslint-disable-next-line
function hasRole(roles, route) {
  if (route.meta && route.meta.roles) {
    return route.meta.roles.includes(roles.id)
  } else {
    return true
  }
}

function filterAsyncRouter (routerMap, roles) {
  const accessedRouters = routerMap.filter(route => {
    if (hasPermission(roles.permissionList, route)) {
      if (route.children && route.children.length) {
        route.children = filterAsyncRouter(route.children, roles)
      }
      return true
    }
    return false
  })
  return accessedRouters
}

const permission = {
  state: {
    routers: [],
    addRouters: [],
    leftRouters:[],
    activeIndex:null,
    flushIndex:1,
  },
  mutations: {
    SET_ROUTERS: (state, routers) => {
      state.addRouters = routers
      state.routers = routers
      console.log(state.routers )
    },
    SET_LEFT_ROUTERS(state,data){
      state.activeIndex = data.active
      Vue.ls.set(TOP_ACTIVE_MENU, data.active)
      state.leftRouters = data.menu
    },
    SET_FLUSH_INDEX(state,data){
      state.flushIndex = state.flushIndex +1;
    },
  },
  actions: {
    GenerateRoutes ({ commit }, data) {
      return new Promise(resolve => {
        let { resource } = data

        const accessedRouters = getRouters(resource)
        commit('SET_ROUTERS', accessedRouters)
        console.log(accessedRouters)
        resolve()
      })
    },
    SetleftRouters({commit},data){
      console.log('重新设置菜单数量====',data)
      commit('SET_LEFT_ROUTERS',data)
    },
    flushIndexActions({commit},data){
      commit('SET_FLUSH_INDEX')
    }
  }
}

export default permission
